import React from 'react';

const Foot = () => {
  return (
    <footer className='bg-black py-8 text-center text-white'>
      <div className='container mx-auto'>
        Copyright &copy; 2022. All rights reserved.
      </div>
    </footer>
  );
};

export default Foot;